export const FBNew = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M27.3903 21.8641L28.2718 16.1165H22.7573V12.3883C22.7573 10.8156 23.5262 9.28155 25.9962 9.28155H28.5049V4.38835C28.5049 4.38835 26.2291 4 24.0544 4C19.5107 4 16.5437 6.75337 16.5437 11.7359V16.1165H11.4951V21.8641H16.5437V35.7592C17.5573 35.9185 18.5942 36 19.6505 36C20.7068 36 21.7437 35.9185 22.7573 35.7592V21.8641H27.3903Z"
            fill="#2774FF"
        />
    </svg>
);
